import React from 'react';

const LetterVisual = ({ revealMeta = {} }) => {
  const stack = revealMeta.tone === 'envelope' || revealMeta.letterCount > 1 ?
    (revealMeta.letterStack?.length ? revealMeta.letterStack : ['Open', 'When']).slice(0, 3) :
    [];
  const paperMeta = revealMeta.letterCount > 1 ? `${revealMeta.letterCount} private notes` : 'Private note';

  return (
    <span className="lumirae-layer-visual lumirae-layer-visual-letter" aria-hidden="true">
      {stack.map((label, index) => (
        <span key={`${label}_${index}`} className={`mini-envelope mini-envelope-${index}`}>
          <b>{index + 1}</b>
        </span>
      ))}
      <span className="flap" />
      <span className="pocket" />
      <span className="paper">
        <strong className="paper-title">{revealMeta.displayTitle || 'A letter for you'}</strong>
        <small className="paper-meta">{paperMeta}</small>
        <i />
        <i />
        <i />
      </span>
      <span className="seal" />
    </span>
  );
};

export default LetterVisual;
